import React from 'react'
import "./Footer.css"
import FilterButtons from './FilterButtons';

const Footer = ({todos, clearCompleted, setFilter, filter}) => {
    const activeTodos = todos.filter((todo) => !todo.completed).length;
  const pronoun = activeTodos <= 1 ? "item" : "items";

  return (
    <div className='footer'>
        <span className='item-left'>{activeTodos} {pronoun} left</span>
        <FilterButtons 
        className = "middle"
        setFilter={setFilter}
        filter={filter} />
        <button
        className='clear-btn' onClick={clearCompleted}>clear completed</button>
    </div>
  )
}

export default Footer